import { render, staticRenderFns } from "./PLP.vue?vue&type=template&id=548461d3&scoped=true&"
import script from "./PLP.vue?vue&type=script&lang=js&"
export * from "./PLP.vue?vue&type=script&lang=js&"
import style0 from "./PLP.vue?vue&type=style&index=0&id=548461d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548461d3",
  null
  
)

export default component.exports